import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { MessageService } from '../message.service';
import { RepoService } from '../repo.service';
import { IdentityLink } from '../identity-link';

@Component({
    selector: 'app-proc-starter',
    templateUrl: './proc-starter.component.html',
    styleUrls: ['./proc-starter.component.scss'],
    standalone: true,
    imports: [RouterModule, ReactiveFormsModule]
})
export class ProcStarterComponent implements OnInit {

  procDefId: string;
  setStarterForm: UntypedFormGroup;

  private formBuilder: UntypedFormBuilder = inject(UntypedFormBuilder);
  private messageService: MessageService = inject(MessageService);
  private repoService: RepoService = inject(RepoService);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);

  constructor() {
    this.procDefId = this.route.snapshot.paramMap.get('id');
    this.setStarterForm = this.formBuilder.group({
      starter: ''
    });
  }

  ngOnInit(): void {
    this.messageService.clear();
  }

  onChange(event) {
    if (event.target.length > 0) {
      this.setStarterForm.get('starter').setValue(event.target.value);
    }
  }

  onSubmit(): void {
    this.messageService.set(`Setting starter...`);
    const starter = this.setStarterForm.get('starter').value;
    const payload: IdentityLink = {
      type: 'candidate'
    };
    starter.indexOf('@') > 0 ? payload.user = starter : payload.group = starter;
    this.repoService
      .setStarter(this.procDefId, payload)
      .subscribe(() => this.router.navigate(['/proc-defs/proc-def-detail', this.procDefId]) );
  }

}
